<template>
  <div class="max-w-lg space-y-4">
    <div
      class="divide-ontick-steel-500 border-ontick-steel-300 text-ontick-carbon-900 dark:bg-ontick-graphite-500 flex flex-col space-y-4 divide-y rounded-lg border-2 p-4 dark:border-none dark:text-gray-300"
    >
      <div class="space-y-4">
        <div>
          <h2 class="text-2xl font-bold">Dados do usuário</h2>
          <p class="text-xs text-gray-500 dark:text-gray-400">Finalize seu cadastro na plaforma.</p>
        </div>

        <ontick-input-component
          label="Nome"
          placeholder="Seu nome"
          name="name"
          bg="bg-ontick-steel-200 dark:bg-ontick-steel-500"
          shadow="shadow-none"
          noBorder
          v-model="user.name"
          :error="errors.first('name')"
          :disabled="true"
        />

        <ontick-input-component
          v-if="user.cpf"
          label="CPF"
          placeholder="000.000.000-00"
          name="cpf"
          bg="bg-ontick-steel-200 dark:bg-ontick-steel-500"
          shadow="shadow-none"
          noBorder
          v-model="user.cpf"
          v-mask="'###.###.###-##'"
          :disabled="true"
        />
        <ontick-input-component
          v-if="user.cnpj"
          label="CNPJ"
          placeholder="00.000.000/0000-00"
          name="cnpj"
          bg="bg-ontick-steel-200 dark:bg-ontick-steel-500"
          shadow="shadow-none"
          noBorder
          v-model="user.cnpj"
          v-mask="'###.###.###-##'"
          :disabled="true"
        />
      </div>
      <div class="space-y-4 pt-4">
        <h3 class="font-bold">Endereço</h3>
        <div class="grid grid-cols-2 gap-4">
          <ontick-input-component
            label="CEP"
            placeholder="00000-000"
            name="cep"
            bg="bg-ontick-steel-200 dark:bg-ontick-steel-500"
            shadow="shadow-none"
            noBorder
            v-validate="'required|length:9'"
            v-model="user.address.cep"
            v-mask="'#####-###'"
            :error="errors.first('cep')"
            :customError="invalidCep ? 'CEP não encontrado' : null"
            :loading="addressIsLoading"
            @input="getCep(user.address.cep)"
          />

          <ontick-input-component
            label="Número"
            placeholder="1000"
            name="number"
            bg="bg-ontick-steel-200 dark:bg-ontick-steel-500"
            shadow="shadow-none"
            noBorder
            v-validate="'required|numeric'"
            v-model="user.address.number"
            :error="errors.first('number')"
          />
          <ontick-input-component
            label="Rua"
            placeholder="Nome da rua"
            name="street"
            bg="bg-ontick-steel-200 dark:bg-ontick-steel-500"
            shadow="shadow-none"
            noBorder
            v-validate="'required'"
            v-model="user.address.street"
            :error="errors.first('street')"
            :maxLength="128"
            class="col-span-full"
          />
          <div class="col-span-full grid grid-cols-5 gap-4">
            <ontick-input-component
              label="Bairro"
              placeholder="Nome do bairro"
              name="neighborhood"
              bg="bg-ontick-steel-200 dark:bg-ontick-steel-500"
              shadow="shadow-none"
              noBorder
              v-validate="'required'"
              v-model="user.address.neighborhood"
              :error="errors.first('neighborhood')"
              class="col-span-full sm:col-span-2"
              :maxLength="64"
            />
            <ontick-input-component
              label="Cidade"
              placeholder="Nome da cidade"
              name="city"
              bg="bg-ontick-steel-200 dark:bg-ontick-steel-500"
              shadow="shadow-none"
              noBorder
              v-validate="'required'"
              v-model="user.address.city"
              :error="errors.first('city')"
              class="col-span-3 sm:col-span-2"
              :maxLength="64"
            />
            <ontick-input-component
              label="UF"
              placeholder="Ex.: SP"
              name="state"
              bg="bg-ontick-steel-200 dark:bg-ontick-steel-500"
              shadow="shadow-none"
              noBorder
              v-validate="'required|length:2'"
              v-model="user.address.state"
              v-mask="'AA'"
              :error="errors.first('state')"
              class="col-span-2 sm:col-span-1"
            />
          </div>
          <ontick-input-component
            label="Complemento"
            placeholder="Casa, apto 101, etc"
            name="complement"
            bg="bg-ontick-steel-200 dark:bg-ontick-steel-500"
            shadow="shadow-none"
            noBorder
            v-model="user.address.complement"
            :error="errors.first('complement')"
            class="col-span-full"
          />
        </div>
      </div>
    </div>
    <div class="flex w-full justify-end">
      <ontick-button
        class="flex w-full items-center space-x-2 sm:w-min"
        @click.native="goToPayerData"
        :disabled="!fieldsAreValid || invalidCep"
      >
        <i v-html="$icons.loading" v-if="submitIsLoading"></i>
        <span> Avançar </span>
      </ontick-button>
    </div>
  </div>
</template>

<script>
import OntickInputComponent from "../../../shared/components/basic/ontick-input.component.vue";
import axios from "axios";
export default {
  components: {
    OntickInputComponent,
  },

  data() {
    return {
      user: {
        name: null,
        cpf: null,
        cnpj: null,
        phone: null,
        email: null,
        address: {
          cep: null,
          number: null,
          street: null,
          neighborhood: null,
          city: null,
          state: null,
          complement: null,
        },
      },
      addressIsLoading: false,
      submitIsLoading: false,
      invalidCep: null,
    };
  },

  computed: {
    fieldsAreValid() {
      let resultsArray = [];
      for (const field in this.fields) {
        resultsArray.push(this.fields[field].valid);
      }
      return resultsArray.every((item) => item === true);
    },
  },

  methods: {
    goToPayerData() {
      this.$validator.validate().then((valid) => {
        if (valid) {
          if (this.invalidCep === true || this.invalidCep === null) {
            this.$swal("Erro", "CEP não encontrado", "error");
          } else {
            const params = {
              user_name: this.user.name,
              user_cpf_cnpj:
                this.user.cpf?.replaceAll(".", "").replaceAll("-", "") ||
                this.user.cnpj?.replaceAll(".", "").replaceAll("-", "").replaceAll("/", ""),
              user_phone: this.user.phone,
              user_email: this.user.email,
              user_cep: this.user.address.cep,
              user_address_number: this.user.address.number,
              user_address: this.user.address.street,
              user_city: this.user.address.city,
              user_state: this.user.address.state,
              user_neighborhood: this.user.address.neighborhood,
            };
            // console.log(params);
            if (this.user.address.complement) {
              params.user_address_complement = this.user.address.complement;
            }
            this.submitIsLoading = true;
            this.$api
              .post(this.$endpoint.POST_USER_INFO, params)
              .then(() => {
                // console.log("SDPGANSDIGFJASDOGFI");
                // const type = this.$route.query.type;
                // const queries = {
                //   plans: {
                //     plan_id: this.$route.query.plan_id,
                //     plan_days: this.$route.query.plan_days,
                //   },
                //   extensions: {
                //     extension_id: this.$route.query.extension_id,
                //   },
                //   products: {
                //     product_id: this.$route.query.product_id,
                //   },
                // };
                // queries[type].type = type;

                // this.$router.push({ name: "Pagamentos", query: queries[type] });
                this.$emit("registered");
              })
              .catch((err) => {
                console.error(err);
                this.$swal("Erro", err.data.msg, "error");
              })
              .finally(() => {
                this.submitIsLoading = false;
              });
          }
        } else {
          this.$swal("Erro", "Dados inválidos", "error");
        }
      });
    },

    getCep(zipCode) {
      if (zipCode.length === 9) {
        if (/^[0-9]{5}-[0-9]{3}$/.test(zipCode)) {
          let new_code = "";
          new_code = zipCode.replace("-", "");
          this.addressIsLoading = true;
          axios
            .get(`https://viacep.com.br/ws/${new_code}/json/`)
            .then((res) => {
              if (res.data.erro) {
                this.invalidCep = true;
              } else {
                for (let item in this.user.address) {
                  if (this.user.address[item] === null) {
                    const actions = {
                      street: () => {
                        this.user.address[item] = res.data.logradouro;
                      },
                      neighborhood: () => {
                        this.user.address[item] = res.data.bairro;
                      },
                      city: () => {
                        this.user.address[item] = res.data.localidade;
                      },
                      state: () => {
                        this.user.address[item] = res.data.uf;
                      },
                      default: () => {},
                    };
                    actions[item] ? actions[item]() : actions.default();
                  }
                }
                this.invalidCep = false;
              }
            })
            .catch((err) => {
              console.error(err);
            })
            .finally(() => {
              this.addressIsLoading = false;
            });
        }
      }
    },

    getUserInfo() {
      this.$api.get(this.$endpoint.GET_USER_INFO).then((res) => {
        const data = res.data;
        this.user = {
          name: data.user_name,
          cpf: data.user_cpf,
          cnpj: data.user_cnpj,
          phone: data.user_phone,
          email: data.user_email,
          address: {
            cep: data.user_cep,
            number: data.user_address_number,
            street: data.user_address,
            neighborhood: data.user_neighborhood,
            city: data.user_city,
            state: data.user_state,
            complement: data.user_address_complement,
          },
        };
        if (this.user.address.cep.length === 9) {
          this.getCep(this.user.address.cep);
        }
      });
    },
  },

  watch: {
    "user.address.cep": {
      deep: true,
      handler(val) {
        if (val?.length !== 9) {
          this.invalidCep = null;
        }
      },
    },
    "user.address.state": {
      handler(val) {
        this.user.address.state = val.toUpperCase();
      },
    },
  },

  created() {
    this.getUserInfo();
  },
};
</script>

<style></style>
